import ReactDOM from "react-dom";
import React, { Component, useState } from "react";
import { Collapse, CardBody, Card } from "reactstrap";
import { Link } from "@reach/router";

import "../css/faq.css";

class EventAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rotateicon: "",
      isOpen: this.props.open,
    };
  }

  accordion = () => {
    if (this.state.rotateicon === "") {
      this.setState({ rotateicon: "collapsed", isOpen: true });
    } else {
      this.setState({ rotateicon: "", isOpen: false });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.open && !prevProps.open) {
      this.setState({ isOpen: true });
    }
  }

  faqParsing = (data) => {
    let p = data.replace("\r", "");
    return p.split("\n\n").map((item, index) => {
      let n = item.indexOf("\n");
      let q = item.substring(0, n);
      let a = item.substring(n, item.length);

      if (n >= 0) {
        return (
          <p>
            <span dangerouslySetInnerHTML={{ __html: q }} /> <br />
            {a.indexOf("#sklink") > 0 ? (
              <>
                <span
                  dangerouslySetInnerHTML={{
                    __html: a.substring(0, a.indexOf("#sklink")),
                  }}
                />
                <button className="none" onClick={this.props.skClick}>
                  Klik disini
                </button>
                <span
                  dangerouslySetInnerHTML={{
                    __html: a.substring(a.indexOf("#sklink") + 7, a.length),
                  }}
                />
                <br />
              </>
            ) : (
              <span dangerouslySetInnerHTML={{ __html: a }} />
            )}
          </p>
        );
      } else return <p dangerouslySetInnerHTML={{ __html: item }} />;
    });
  };

  skParsing = (data) => {
    let p = data.replace("\r", "");
    //console.log(p);
    return (
      <ol>
        {p.split("\n\n").map((item, index) => (
          <React.Fragment key={index}>
            <div dangerouslySetInnerHTML={{ __html: item }} />
          </React.Fragment>
        ))}
      </ol>
    );
  };

  render() {
    return (
      <>
        <Card>
          <div
            onClick={this.accordion}
            className={["card-header", this.state.rotateicon].join(" ")}
            data-toggle="collapse"
          >
            <span>{this.props.title}</span>
            <span>
              <div className="fa"></div>
            </span>
          </div>
          <Collapse isOpen={this.state.isOpen}>
            <CardBody className="card-body">
              {this.props.type == "faq"
                ? this.faqParsing(this.props.data)
                : this.skParsing(this.props.data)}
            </CardBody>
          </Collapse>
        </Card>
      </>
    );
  }
}

export default EventAccordion;
